import { FC } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

interface ConfigModeSwitchDialogProps {
  open: boolean
  currentMode: 'simple' | 'advanced'
  targetMode: 'simple' | 'advanced'
  onConfirm: (shouldConvert: boolean) => void
  onCancel: () => void
}

export const ConfigModeSwitchDialog: FC<ConfigModeSwitchDialogProps> = ({
  open,
  currentMode,
  targetMode,
  onConfirm,
  onCancel,
}) => {
  const isSimpleToAdvanced = currentMode === 'simple' && targetMode === 'advanced'
  const isAdvancedToSimple = currentMode === 'advanced' && targetMode === 'simple'

  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogTitle>
        {isSimpleToAdvanced ? 'Switch to Advanced Mode?' : 'Switch to Simple Mode?'}
      </DialogTitle>
      <DialogContent>
        {isSimpleToAdvanced ? (
          <>
            <DialogContentText>
              You are switching from Simple to Advanced mode. What would you like to do with your
              current configuration?
            </DialogContentText>
            <DialogContentText sx={{ mt: 2, fontWeight: 'bold' }}>
              • Convert: Your current Simple configuration will be converted to Advanced mode
              (recommended)
            </DialogContentText>
            <DialogContentText sx={{ fontWeight: 'bold' }}>
              • Start Fresh: Advanced mode will start with an empty configuration
            </DialogContentText>
          </>
        ) : isAdvancedToSimple ? (
          <>
            <DialogContentText sx={{ color: 'error.main', fontWeight: 'bold' }}>
              Warning: Switching to Simple mode will delete your Advanced configuration!
            </DialogContentText>
            <DialogContentText sx={{ mt: 2 }}>
              Your current Advanced mode template (itemTemplate) will be permanently removed and
              replaced with Simple mode configuration (rows and icon).
            </DialogContentText>
            <DialogContentText sx={{ mt: 2 }}>
              Are you sure you want to continue?
            </DialogContentText>
          </>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color='inherit'>
          Cancel
        </Button>
        {isSimpleToAdvanced ? (
          <>
            <Button onClick={() => onConfirm(false)} color='primary' variant='outlined'>
              Start Fresh
            </Button>
            <Button onClick={() => onConfirm(true)} color='primary' variant='contained'>
              Convert
            </Button>
          </>
        ) : (
          <Button onClick={() => onConfirm(false)} color='error' variant='contained'>
            Yes, Switch to Simple
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}



